import { defineMessages } from 'react-intl';

export default defineMessages({
  authSnackbarInvitationEmail: {
    defaultMessage: 'Invitation email was sent successfully.',
    description: 'Auth snackbar - Invitation email',
    id: 'authSnackbarInvitationEmail',
  },
  authSnackbarPasswordReset: {
    defaultMessage: 'Password reset successful, a verification e-mail has been sent to your e-mail.',
    description: 'Auth snackbar - Password reset',
    id: 'authSnackbarPasswordReset',
  },
  authSnackbarTooManyResends: {
    defaultMessage: 'You can resend the invitation once every 15 minutes. Try again later.',
    description: 'Auth error snackbar - Resend email spam',
    id: 'authSnackbarInvitationEmail.error.tooManyResends',
  },
});
